import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('data-token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const auth = {
  getConfig: () => api.get('/auth/config'),
  microsoftStart: () => api.get('/auth/microsoft/start'),
  microsoftCallback: (code, state) => api.post('/auth/microsoft/callback', { code, state }),
  getMe: () => api.get('/auth/me'),
};

export const sources = {
  liste: () => api.get('/sources'),
  scanner: () => api.post('/sources/scan'),
  modifier: (code, champs) => api.patch(`/sources/${code}`, champs),
  ingerer: (code) => api.post(`/sources/${code}/ingerer`),
  schemaVu: (code) => api.post(`/sources/${code}/schema-vu`),
  reingererTout: () => api.post('/sources/reingerer'),
  reingestion: () => api.get('/sources/reingestion'),
};

export default api;
